const ews = ews || {};
ews.components = ews.components || {};
ews.components.header = ews.components.header || {};

ews.components.header.meganav = function() {
    const DELAY_TIMER = 300;
    const menuItems = $('.btmNav > li');
    const menuDeferreds = [];
    const menuData = [];
    let overlayWidth = 0;
    let closeTimer;
    let openTimer;
    let megaNavElement;
    let megaNavContainerElement;
    let documentElement;
    let overlay;

    function init() {
        createMenuData(menuItems);
    }

    function createMenuData($links) {

        const esiinclude = _detectEsi();

        for (let i = 0; i < $links.length; i++) {
            const $category = $($links[i]),
                overlayUrl = $category.data('overlay-href');

            if (!overlayUrl) {
                // no overylay html (e.g. direct links).
                _addMenuData(null, $category, i);
            } else if (esiinclude) {
                // non esi supported (e.g. NON AKAMI)
                _menuAddDeferred(overlayUrl, $category, i);
            } else {
                // esi supported (e.g. AKAMI)
                const overlayHtml = $('#megaMenuLink_' + i).html();
                _addMenuData(overlayHtml, $category, i);
            }
        }

        if (esiinclude) {
            $.when.apply(null, menuDeferreds).done(menuAjaxDone);
        } else {
            menuAjaxDone();
        }
    }

    function getMenuData() {
        return menuData.sort(sortById);
    }

    function menuAjaxDone() {

        const sortedMenuData = getMenuData();
        let megaNavTabCounter = 0;
        megaNavElement = $('.mega-navigation');
        sortedMenuData.forEach(function(item) {

            const $itemNav = $(menuItems[megaNavTabCounter]);

            if (!!item.data && $itemNav.hasClass('dropdown')) {
                $itemNav.attr('data-overlay-id', megaNavTabCounter);
                const panelId = 'megaMenuPanel-' + megaNavTabCounter;
                megaNavElement.prepend($.parseHTML('<div class="mega-nav-tab mega-nav-tab-' + megaNavTabCounter + '">' + item.data + '</div>'));
                $itemNav.find('> a').attr('aria-controls', panelId);
            }
            megaNavTabCounter = megaNavTabCounter + 1;
            window.megaNavLoaded = true;
        });

        addClickEvents();
        addKeyboardEvents()
    }

    function addKeyboardEvents() {
        setupAriaForTopLevel();

        const $topLevelAnchors = menuItems.find('> a');
        $topLevelAnchors.on('keydown', function (e) {
            const $anchor = $(this);
            const $li = $anchor.closest('li');
            const itemId = $li.data('overlay-id');

            switch (e.key) {
                case 'ArrowDown':
                    if ($li.hasClass('dropdown') && itemId !== undefined) {
                        e.preventDefault();
                        if (!megaNavContainerElement.hasClass('open')) {
                            openMegaNav(itemId);
                        } else {
                            displayMenuItem(itemId);
                        }
                        setAriaExpandedForTopLevel(itemId, true);
                        focusFirstItemInPanel(itemId);
                    }
                    break;

                case 'Escape':
                    if (isOpen()) {
                        e.preventDefault();
                        closeMegaNav();
                        $anchor.attr('aria-expanded', 'false').focus();
                    }
                    break;

                case ' ':
                    e.preventDefault();
                    const href = $anchor.attr('href');
                    if (href && href !== '#') window.location.href = href;
                    break;
            }
        });

       megaNavElement.on('keydown', '.mega-nav-tab.open', function (e) {
        const $panel = $(this);
        const $items = getFocusableIn($panel);
        if (!$items.length) return;

        const currentIndex = $items.index($(document.activeElement));

        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            const at = Math.max(0, currentIndex);
            const nextIndex = (e.key === 'ArrowDown')
                ? Math.min(at + 1, $items.length - 1)
                : Math.max(at - 1, 0);

            e.preventDefault();
            $items.eq(nextIndex).focus();
            return;
        }

        if (e.key === 'Tab' && !e.shiftKey && currentIndex === $items.length - 1) {
            e.preventDefault();

            const topIndex = getCurrentOpenTopIndex();
            const nextIndex = topIndex + 1;
            const $nextMenu = $(menuItems[nextIndex]);
            if ($nextMenu.length) {
                closeMegaNav(); 
                $nextMenu.find('> a').focus();
            } else {
                closeMegaNav();
            }
            return;
        }

        if (e.key === 'Tab' && e.shiftKey && currentIndex === 0) {
            e.preventDefault();
            const topIndex = getCurrentOpenTopIndex();
            closeMegaNav();
            $(menuItems[topIndex]).find('> a').focus();
        }

        if (e.key === 'Escape') {
            e.preventDefault();
            const topIndex = getCurrentOpenTopIndex();
            closeMegaNav();
            if (typeof topIndex === 'number') {
                const $topAnchor = $(menuItems[topIndex]).find('> a');
                $topAnchor.attr('aria-expanded', 'false').focus();
            }
        }
    });
    ``
    }

    function setupAriaForTopLevel() {
        menuItems.each(function () {
            const $li = $(this);
            const $a = $li.find('> a');
            const isDropdown = $li.hasClass('dropdown') && typeof $li.data('overlayId') !== 'undefined';
            if (isDropdown) {
                $a.attr({
                    'aria-haspopup': 'menu',
                    'aria-expanded': $a.attr('aria-expanded') || 'false'
                });
            } else {
                $a.removeAttr('aria-haspopup aria-expanded aria-controls');
            }
        });
    }

    function setAriaExpandedForTopLevel(openId, isExpanded) {
        menuItems.each(function () {
            const $li = $(this);
            const liId = $li.data('overlay-id');
            const $a = $li.find('> a');
            if ($li.hasClass('dropdown') && typeof liId !== 'undefined') {
                $a.attr('aria-expanded', (isExpanded && liId === openId) ? 'true' : 'false');
            }
        });
    }

    function focusFirstItemInPanel(itemId) {
        const $panel = megaNavElement.find('.mega-nav-tab-' + itemId);
        const $items = getFocusableIn($panel);
        if ($items.length) $items.eq(0).focus();
    }

    function getFocusableIn($root) {
        return $root.find('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])').filter(':visible');
    }

    function getCurrentOpenTopIndex() {
        const idx = $(menuItems).index($(menuItems).filter('.open')[0]);
        return (idx >= 0) ? idx : undefined;
    }

    function addClickEvents() {
        megaNavContainerElement = $('.mega-navigation__container');
        overlay = $('.overlay');

        documentElement = $(document.documentElement);

        const $anchor = menuItems.find('a');

        $anchor.on('mouseenter', function() {
            const $selectedTab = $(this).closest('li'),
                itemId = $selectedTab.data('overlay-id'),
                relNavWrapper = document.querySelector(`.mega-nav-tab-${itemId}`);

            if (closeTimer) {
                clearTimeout(closeTimer);
            }

            openTimer = setTimeout(() => {
                if (!relNavWrapper || !$selectedTab.hasClass('dropdown')) {
                    closeMegaNav();
                    return true;
                }

                if (!$selectedTab.data('overlayHref')) {
                    return;
                }

                if (megaNavContainerElement.hasClass('open')) {
                    displayMenuItem(itemId);
                } else {
                    openMegaNav(itemId);
                }
            }, DELAY_TIMER);
        });

        $anchor.on('mouseleave', () => {
            if (openTimer) {
                clearTimeout(openTimer);
            }
            clearTimeout(closeTimer);
            closeTimer = setTimeout(() => {
                closeMegaNav();
            }, DELAY_TIMER);
        });

        $anchor.on('click', function(event) {
            event.preventDefault();

            const href = $(this).attr('href');
            // menuName = $.trim($(this).text()),
            // exdate = new Date();

            if (href != '#') {
                // Cookie
                // exdate.setDate(exdate.getDate() + 30);
                // document.cookie = "category" + escape(menuName) + ";expires=" + exdate;
                // carry on with redirect
                window.location.href = href;
            }
        });

        megaNavElement.find('.subCatHldr a').on('click', function(e) {
            e.stopImmediatePropagation();
        });
    }

    function openMegaNav(id) {
        // check if width has not been assigned for overlay
        if (!overlayWidth) {
            _setOverlayWidth();
        }
        megaNavContainerElement.addClass('open');
        displayMenuItem(id);
        documentElement.addClass('header-active');
        overlay.addClass('overlay--menu');
        overlay.removeClass('hide');
    }

    function closeMegaNav() {
        megaNavContainerElement.removeClass('open');
        $(menuItems).removeClass('open');
        documentElement.removeClass('header-active');
        overlay.removeClass('overlay--menu');
        overlay.addClass('hide');
        setAriaExpandedForTopLevel(null, false);
    }

    function _setOverlayWidth() {
        overlayWidth = $('.btmNav').outerWidth();
        megaNavElement.css('min-width', overlayWidth);
    }

    function isOpen() {
        return (!!megaNavContainerElement.hasClass('open'));
    }

    function displayMenuItem(id) {
        const $target = megaNavElement.find('.mega-nav-tab-' + id);

        clearMegaNav();

        $(menuItems[id]).addClass('open');

        megaNavElement.css('min-height', megaNavElement.find('.mega-nav-tab-' + id).height() + 50 + 'px');

        CPW.Plugins.lazyLoad($target.find('img[data-src]'));
        $target.addClass('open');
        setAriaExpandedForTopLevel(id, true);

        if (!$(menuItems[id]).hasClass('rendered')) {
            $(menuItems[id]).addClass('rendered');
        }

        $target.on('mouseenter', () => {
            if (closeTimer) {
                clearTimeout(closeTimer);
            }
        });

        $target.on('mouseleave', () => {
            if (openTimer) {
                clearTimeout(openTimer);
            }
            clearTimeout(closeTimer);
            closeTimer = setTimeout(() => closeMegaNav(), DELAY_TIMER);
        });
    }

    function clearMegaNav() {
        $(menuItems).removeClass('open');
        megaNavElement.find('.mega-nav-tab').removeClass('open');
    }

    function sortById(a, b) {
        return a.id - b.id;
    }

    /* Populate menuData via Ajax */
    function _menuAddDeferred(url, $category, id) {
        menuDeferreds.push(
            $.get(url, {}).success(function(data) {
                _addMenuData(data, $category, id);
            })
        );
    }

    function _detectEsi() {
        const elNavBar = document.getElementById('Search_nav');

        // override esi tags if required
        if (!!elNavBar && elNavBar.dataset.forceAjax === 'true') {
            return true;
        }

        return (
            $('#megaMenuLink_0').html().match(/<esi:include/g) != null &&
            $('#megaMenuLink_0').html().match(/<esi:include/g) != ' '
        );
    }

    function _addMenuData(data, $category, id) {
        const menuDataObject = {};
        menuDataObject.id = id;
        menuDataObject.data = data;
        menuDataObject.$category = $category;
        menuData.push(menuDataObject);
    }

    const showLastText = () => {
        if ($('.mvbreadCrumbWrapPdp')[0] ) {
            $('.mvbreadCrumbWrapPdp').scrollLeft( $('.mvbreadCrumbWrapPdp').width());
        }  
    };

    init();
    showLastText();
    return {
        init,
        closeMegaNav,
        openMegaNav,
        isOpen,
        getMenuData
    };
}();